<template>
  <div class="subscriptions-page pa-4">
    <h4 class="mb-2">Hello {{ partnerUser.first_name }},</h4>
    <div class="caption">
      Update your preferences below for which emails you'd like to receive.
    </div>

    <h5 class="my-4" for="Info">
      Subscriptions
    </h5>
    <v-col class="pa-0" cols="auto">
      <div
        v-for="(sub, idx) in subscriptions"
        :key="`${sub.id}-${idx}`"
        class="d-flex align-center"
      >
        <v-col cols="1" class="pa-0">
          <v-checkbox
            color="primary"
            :id="`sub-${sub.id}-${idx}`"
            v-model="sub.subscribed"
            class="me-2 my-0 mt-1"
            hide-details
            @update:modelValue="unsubscribe(sub, $event)"
          ></v-checkbox>
        </v-col>
        <v-col cols="11 subscription-name">
          <label :for="`sub-${sub.id}-${idx}`" v-html="sub.name"></label>
          <div
            v-if="sub.description"
            class="caption mb-0"
            v-html="sub.description"
          ></div>
        </v-col>
      </div>
    </v-col>

    <h5 class="my-4">
      Unsubscribe from all email lists.
    </h5>

    <v-btn
      class="unsubscribe-all-btn"
      color="primary"
      :disabled="allSubscribed"
      size="large"
      variant="outlined"
      @click="unsubscribeAll()"
    >
      Unsubscribe All
    </v-btn>

    <v-snackbar
      absolute
      class="subscriptions-snackbar"
      color="primary"
      :timeout="snackbarTimer"
      v-model="snackbar"
    >
      Subscription settings updated
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Subscriptions',
  data() {
    return {
      allSubscribed: null,
      loading: true,
      subscriptions: [],
      snackbar: false,
      snackbarTimer: 2000
    };
  },
  computed: {
    ...mapState(['offer', 'partnerUser', 'partner'])
  },
  methods: {
    checkAllSubscribed() {
      return (this.allSubscribed = this.subscriptions.every(
        v => !v.subscribed
      ));
    },

    async getMessageListSubscriptions() {
      try {
        const {
          data
        } = await this.$api.subscriptions.getMessageListSubscriptions(
          this.partnerUser.id,
          this.offer.id,
          { offerId: this.offer.id }
        );

        this.subscriptions = data;
      } catch (error) {
        console.error('Failed to grab subscription list', error);
      }
    },

    async unsubscribeAll() {
      this.useSnackbarTimeout();

      for (const sub of this.subscriptions) {
        if (sub.subscribed) {
          sub.subscribed = 0;
          this.checkAllSubscribed();
          await this.$api.subscriptions.updateSubscriptions(
            { id: sub.id, subscribed: sub.subscribed ? 1 : 0 },
            this.partnerUser.id,
            this.partner.id
          );
        }
      }
    },

    unsubscribe(sub, value) {
      this.useSnackbarTimeout();
      if (typeof value !== 'undefined') {
        sub.subscribed = value;
      }

      this.$api.subscriptions.updateSubscriptions(
        { id: sub.id, subscribed: sub.subscribed ? 1 : 0 },
        this.partnerUser.id,
        this.partner.id
      );
      this.checkAllSubscribed();
    },

    useSnackbarTimeout() {
      this.snackbar = true;
      setTimeout(() => {
        this.snackbar = false;
      }, this.snackbarTimer);
    }
  },

  async created() {
    await this.getMessageListSubscriptions();
    this.checkAllSubscribed();
    this.loading = false;
  }
};
</script>

<style scoped>
.unsubscribe-all-btn {
  font-size: 0.875rem;
  height: 40px;
  min-height: 40px;
  border-radius: 9999px !important;
  padding: 0 17.01px !important;
}
.subscription-name.v-col {
    padding: 8px 8px;
}
.subscriptions-snackbar {
  bottom: 34px !important;
}
</style>
